import React from 'react';
import termos from '@/docs/legal/termos.md?raw';
import { LegalPage } from './LegalPage';

/** `/termos` — Termos de uso (pública; texto em src/docs/legal/termos.md). */
export const TermsView: React.FC = () => (
  <LegalPage source={termos} sibling={{ to: '/privacidade', label: 'Política de privacidade' }} />
);

export default TermsView;
